import * as React from 'react'
import './OrderItem.scss'
import { orderType, selectWalletType } from "../../reducers/types";
import alipayImg from '../../images/alipay.svg';
import wechatImg from '../../images/wechatpay.svg';
import alipayPlusImg from '../../images/alipayplus.svg';
import appleImg from '../../images/apple.svg';
import googleImg from '../../images/google.svg';
import creditCardImg from '../../images/card.svg';

interface IProps {
  order: orderType,
  selectWallet: selectWalletType,
  onClick: () => void
}

const walletIcons: { [key: string]: any } = {
  'Alipay': alipayImg,
  'Wechat': wechatImg,
  'AlipayPlus': alipayPlusImg,
  'ApplePay': appleImg,
  'GooglePay': googleImg,
  'CreditCard': creditCardImg
}


class OrderItem extends React.Component<IProps, {}> {

  getWalletLogo = (wallet: string) => {
    const walletInfo = this.props.selectWallet[wallet];
    if (walletInfo && walletInfo.logo) {
      return walletInfo.logo;
    }
    return walletIcons[wallet] || null;
  }

  public render() {
    const walletLogo = this.getWalletLogo(this.props.order.wallet);
    return (<div className="OrderItem" onClick={this.props.onClick}>
      <div className="left">
        <div>
          {walletLogo ? (
            <img src={walletLogo} className="walletIcon" alt={this.props.order.wallet} style={{ width: '20px', height: '20px' }} />
          ) : (
            <span className="walletName" style={{ fontSize: '12px', color: '#666' }}>{this.props.selectWallet[this.props.order.wallet]?.name || this.props.order.wallet}</span>
          )}
          <span className="tradeTime">{this.props.order.tradeTime}</span>
        </div>
        <div className="tradeSummary">{this.props.order.buyer || this.props.order.tradeSummary}</div>
      </div>
      <div className={`tradeAmt ${this.props.order.type === 0 ? '' : 'red'}`}>{this.props.order.type === 0 ? '+' : '-'}{this.props.order.tradeAmt}</div>
      <div className={`tradeAmt ${this.props.order.type === 0 ? '' : 'red'}`}>{this.props.order.currency}</div>
    </div>);
  }
}
export default OrderItem
